

export const monicaBio = {
  _id: 'monicaBioId',
  userId: 'monicaUserId',
  email: 'monica@email.com',
  aboutMe: [
    `Obsessive compulsive professional looking for someone who doesn't mind being bossed around as long as the food is good — yes, I should probably just get a dog`,
    `An obsessively clean and competitive perfectionist looking for someone relaxed to even me out`,
    `New Yorker into shoes, restaurants, and melodrama`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `Someone relaxed to even me out`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Sundays in the park, going to a gallery and forgetting to look at the art, and when curtains match the bedsheets`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Favorite pasta shape`,
    }
  ],
  hobbies: [
    `Fashion`,
    `Design`,
    `Restaurants`,
    `Coffee`,
    `Cooking`
  ],
  vitalInfo: {
    firstName: `Monica`, 
    age: 30,
    gender: `Female`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Men`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 65,
    heightCM: 166,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `Long Island`,
    languages: [`English`, `French`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: `Undergrad`,
    university: `Culinary School`,
    profession: `Chef`,
    employer: `Upscale Restaurant`,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Yes`,
    cigarettes: `No`,
    weed: `No`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}

export const rachelBio = {
  _id: 'rachelBioId',
  userId: 'rachelUserId',
  email: 'rachel@email.com',
  aboutMe: [
    `Spoiled, inexperienced daddy's girl, embarking on a journey toward independence, starting out as a waitress`,
    `My friends ask me for fashion advice, and I ask them for advice about everything else — let's pretend the exchange is even`,
    `Waitress at Central Perk, looking for her own Central Perk`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `My own Central Perk`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Hair, nails, shopping, and spa — hey at least I didn't add in avocado toast`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Is it a good thing when your best friend dates your brother?`,
    }
  ],
  hobbies: [
    `Fashion`,
    `Restaurants`,
    `Spa`,
    `Melodrama`,
    `Being Clumsy`
  ],
  vitalInfo: {
    firstName: `Rachel`, 
    age: 29,
    gender: `Female`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Men`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 66,
    heightCM: 168,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `Long Island`,
    languages: [`English`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: `Undergrad`,
    university: `NYU`,
    profession: `Waitress`,
    employer: `Central Perk`,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Sometimes`,
    cigarettes: `No`,
    weed: `No`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}

export const joeyBio = {
  _id: 'joeyBioId',
  userId: 'joeyUserId',
  email: 'joey@email.com',
  aboutMe: [
    `As the only boy in a household with seven sisters I'm prepared for whatever drama is thrown at me`,
    `Warning: Will eat all your food while you're in the bathroom`,
    `I'm not a doctor, but I play one on TV (literally)`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `A steady acting job`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Eating all your fries`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `How YOU doin`,
    }
  ],
  hobbies: [
    `Acting`,
    `Eating`,
    `Coffee`,
    `Bars`,
    `Friends`
  ],
  vitalInfo: {
    firstName: `Joey`, 
    age: 30,
    gender: `Male`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Women`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 72,
    heightCM: 185,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `Queens`,
    languages: [`English`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: ``,
    university: ``,
    profession: `Actor`,
    employer: `TV`,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Sometimes`,
    cigarettes: `No`,
    weed: `No`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}

export const rossBio = {
  _id: 'rossBioId',
  userId: 'rossUserId',
  email: 'ross@email.com',
  aboutMe: [
    `Data analyst with a low variance and a high confidence interval`,
    ``,
    ``
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `A relationship more stable than the one my parents had — oh no, was that a trauma dump already`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Hanging out at the coffee shop with my friends`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Is it worth it to be bored in a well-paid job?`,
    }
  ],
  hobbies: [
    `Sarcasm`,
    `Restaurants`,
    `Coffee`,
    `Scheming`,
    `Neuroticism`
  ],
  vitalInfo: {
    firstName: `Ross`, 
    age: 32,
    gender: `Male`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Women`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 74,
    heightCM: 187,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `Long Island`,
    languages: [`English`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: `Postgrad`,
    university: `Columbia University`,
    profession: `Paleontologist`,
    employer: `Columbia University`,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Sometimes`,
    cigarettes: `No`,
    weed: `No`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}